import { getDeepStateForSession } from "@/stores/ai-explorer-store"

type DeepStateContainer = Parameters<typeof getDeepStateForSession>[0]

export function getArtifactSessionProposedTodos(
  state: DeepStateContainer,
  artifactSessionId: string
) {
  return getDeepStateForSession(state, artifactSessionId).proposedTodos
}

export type M365HomePromptInput = {
  isChatHomeVisible: boolean
  showM365Option: boolean
  showPersonalizedHome: boolean
  hasM365Approval: boolean
  hasDeclinedM365: boolean
  isM365ApprovalLoading: boolean
  hasDismissedM365HomePrompt: boolean
  onboardingOverlayActive: boolean
}

/**
 * Whether the chat home should auto-open the Microsoft 365 consent dialog.
 *
 * Every input is a reason NOT to prompt except the first three (the home must
 * be showing, the tool enabled, and the personalized home allowed). The
 * onboarding gate matters most: the wizard renders on top of this page as a
 * modal Radix Dialog, and a consent AlertDialog that mounts after it becomes
 * the topmost dismissable layer, which makes Radix disable pointer events on
 * the wizard. The user then sees the wizard but cannot click it (#2946). The
 * prompt re-evaluates once the overlay clears, so consent is still asked —
 * just after onboarding instead of underneath it.
 */
export function shouldAutoPromptM365Consent(input: M365HomePromptInput): boolean {
  return (
    input.isChatHomeVisible &&
    input.showM365Option &&
    input.showPersonalizedHome &&
    !input.hasM365Approval &&
    !input.hasDeclinedM365 &&
    !input.isM365ApprovalLoading &&
    !input.hasDismissedM365HomePrompt &&
    !input.onboardingOverlayActive
  )
}
